module.exports = __webpack_public_path__ + "static/ext1-7b7006e2bca3efee8c200031122727b3.png";